/* eslint-disable graphql/template-strings */
/* eslint-disable max-len */
import { Injectable } from '@angular/core';
import AWSAppSyncClient from 'aws-appsync';
import { DocumentNode } from 'graphql';
import { gql } from 'graphql-tag';
import { filter, map } from 'rxjs/operators';
import {
  AzzurroHubModbusRes,
} from '..';

import { GraphqlApiService } from '../../graphql-api/graphql-api.service';
import { isNotNullOrUndefined } from '../../utils';

export interface OnReceiveModbuscommandForAHInput {
  gatewaySN?: string;
}
const build = (_query: DocumentNode, input: OnReceiveModbuscommandForAHInput, name = 'QueryResult') => {
  const bQuery = `
  subscription ${ name }(`+
    ( input.gatewaySN !== undefined ? `$gatewaySN: String = ${JSON.stringify(input.gatewaySN).replace(/"(\w+)":/g, '$1:')}` : '' ) + `){
    onReceiveModbuscommandForAH(
      ${ input.gatewaySN !== undefined ? 'gatewaySN: $gatewaySN,' : '' }
    ){
      ...azzurrohubmodbusres
    }
  }`;
  return gql`
  ${bQuery}
  ${_query}
`};

@Injectable({
  providedIn: 'root',
})
export class OnReceiveModbuscommandForAHSubscription {
  readonly graphqlClient$ = this.graphqlApiService.client$.pipe(
    filter((available) => !!available),
  );

  readonly build = build;

  constructor(
    private readonly graphqlApiService: GraphqlApiService,
  ) { }

  /**
   * fragment azzurrohubmodbusres on AzzurroHubModbusRes { ... }
   */
  execute(_query: DocumentNode, input: OnReceiveModbuscommandForAHInput) {
    return this.graphqlClient$.pipe(
      isNotNullOrUndefined(),
      map((client: AWSAppSyncClient<any>) =>
        client.subscribe<{ data : {  onReceiveModbuscommandForAH : Partial<AzzurroHubModbusRes>} }>({ query: build(_query, input) }),
      ),
    );
  }
}
